{
  "generated_at": "2026-10-14T10:28:04.483Z",
  "export_after_date": "2023-01-01",
  "export_boundary_inclusive": false,
  "total_rows": 715,
  "sources": [
    {
      "election": 26,
      "url": "https://themadad.com/allpolls/",
      "rows": 717,
      "date_min": "2022-12-23",
      "date_max": "2026-10-11",
      "poll_id_min": 1,
      "poll_id_max": 757,
      "distinct_poll_ids": 717,
      "raw_headers": [
        "מספר הסקר",
        "תאריך",
        "משיבים",
        "כלי תקשורת",
        "עורך משאלים",
        "הליכוד",
        "יהדות התורה",
        "ש״ס",
        "כחול לבן",
        "יש עתיד",
        "חדש תע״ל",
        "ישראל ביתנו",
        "הדמוקרטים",
        "הציונות הדתית / זהות",
        "רע״מ",
        "בל״ד",
        "עוצמה יהודית",
        "ביחד (בנט ולפיד)",
        "ישר!",
        "המילואימניקים / זליכה",
        "הרשימה המשותפת",
        "מפלגה בראשות גלעד ארדן ויולי אדלשטיין",
        "עמך ישראל"
      ],
      "english_headers": [
        "poll_id",
        "date",
        "respondents",
        "media_outlet",
        "pollster",
        "likud",
        "united_torah_judaism",
        "shas",
        "blue_and_white",
        "there_is_a_future",
        "hadash_taal",
        "israel_our_home",
        "the_democrats",
        "religious_zionism_identity",
        "raam",
        "balad",
        "jewish_power",
        "together",
        "yashar",
        "unmapped_party_01",
        "joint_list",
        "erdan_edelstein_party",
        "unmapped_party_02"
      ]
    },
    {
      "election": 25,
      "url": "https://themadad.com/allpolls25/",
      "rows": 156,
      "date_min": "2021-04-06",
      "date_max": "2022-10-28",
      "poll_id_min": 1,
      "poll_id_max": 168,
      "distinct_poll_ids": 156,
      "raw_headers": [
        "מספר הסקר",
        "תאריך",
        "משיבים",
        "כלי תקשורת",
        "עורך משאלים",
        "הליכוד",
        "הציונות הדתית",
        "יהדות התורה",
        "ש\"ס",
        "ישראל ביתנו",
        "המחנה הממלכתי",
        "יש עתיד",
        "מרצ",
        "עבודה",
        "עוצמה",
        "המפלגה הכלכלית",
        "המשותפת",
        "רע\"מ",
        "הרוח הציונית",
        "תקווה חדשה"
      ],
      "english_headers": [
        "poll_id",
        "date",
        "respondents",
        "media_outlet",
        "pollster",
        "likud",
        "religious_zionism",
        "united_torah_judaism",
        "shas",
        "israel_our_home",
        "national_unity",
        "there_is_a_future",
        "meretz",
        "labor",
        "jewish_power",
        "economic_party",
        "joint_list",
        "raam",
        "zionist_spirit",
        "new_hope"
      ]
    },
    {
      "election": 24,
      "url": "https://themadad.com/%D7%A1%D7%A7%D7%A8%D7%99%D7%9D-%D7%9C%D7%91%D7%97%D7%99%D7%A8%D7%95%D7%AA-%D7%9C%D7%9B%D7%A0%D7%A1%D7%AA-24-%D7%9E%D7%A8%D7%A5-2021/",
      "rows": 127,
      "date_min": "2020-08-06",
      "date_max": "2021-03-19",
      "poll_id_min": 1,
      "poll_id_max": 1184,
      "distinct_poll_ids": 127,
      "raw_headers": [
        "מספר הסקר",
        "תאריך",
        "משיבים",
        "כלי תקשורת",
        "עורך משאלים",
        "הליכוד",
        "תקווה חדשה",
        "ימינה",
        "הציונות הדתית",
        "יהדות התורה",
        "ש\"ס",
        "ישראל ביתנו",
        "כחול לבן",
        "יש עתיד",
        "הישראלים",
        "מרצ",
        "עבודה",
        "המפלגה הכלכלית",
        "המשותפת",
        "רע\"מ"
      ],
      "english_headers": [
        "poll_id",
        "date",
        "respondents",
        "media_outlet",
        "pollster",
        "likud",
        "new_hope",
        "yamina",
        "religious_zionism",
        "united_torah_judaism",
        "shas",
        "israel_our_home",
        "blue_and_white",
        "there_is_a_future",
        "the_israelis",
        "meretz",
        "labor",
        "economic_party",
        "joint_list",
        "raam"
      ]
    }
  ],
  "audit_summary": {
    "respondent_outliers": 1,
    "source_poll_id_outliers": 0,
    "exact_payload_duplicate_groups": 2
  }
}
